import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        scroll-behavior: smooth;
    }

    #root, html, body, .App {
        min-height: 100vh;
    }

    ul {
        list-style: none;
    }

    a {
        text-decoration: none;
        color: inherit;
        cursor: pointer;
    }

    button {
        cursor: pointer;
        font-family: 'flama';
    }

    span {
        font-family: 'flama';
    }

    input[type="checkbox"] {
        -webkit-appearance: none;
        appearance: none;
        background-color:transparent;
        margin: 0;
        display: grid;
        place-content: center;
    }

    input[type="checkbox"]:checked::before {
        transform: scale(1);
    }

    .priority_modal {
        z-index: 3;
    }

    .modal__right-enter {
        opacity: 0;
        transform: translateX(100%);
    } 
    .modal__right-enter-active{
        opacity: 1;
        transform: translateX(0);
        transition: all 200ms;  
    }


    .modal__right-exit {
        opacity: 1;
        transform: translateX(0);
    }

    .modal__right-exit-active {
        opacity: 0;
        transform: translateX(100%);
        transition: all 200ms;  
    }

    .top_bottom_effect-enter {
        opacity: 0;
    } 

    .opacity__effect-enter{
        opacity:0;
    }

    .opacity__effect-enter-active{
        opacity: 1;
        transition: all 200ms;  
    }


    .opacity__effect-exit {
        opacity: 1;
    }

    .opacity__effect-exit-active {
        opacity: 0;
        transition: all 200ms;  
    }

    .top_bottom_effect-enter {
        opacity: 0;
        transform: translateY(-100%);
    } 
    .top_bottom_effect-enter-active{
        opacity: 1;
        transform: translateY(0);
        transition: all 400ms;  
    }

    .top_bottom_effect-exit {
        opacity: 1;
        transform: translateY(0);
    }

    .top_bottom_effect-exit-active {
        opacity: 0;
        transform: translateY(-100%);
        transition: all 400ms;  
    }

    .top_bottom_weak_effect-enter {
        opacity: 0;
        transform: translateY(-10%);
    } 
    .top_bottom_weak_effect-enter-active{
        opacity: 1;
        transform: translateY(0);
        transition: all 400ms;  
    }

    .top_bottom_weak_effect-exit {
        opacity: 1;
        transform: translateY(0);
    }

    .top_bottom_weak_effect-exit-active {
        opacity: 0;
        transform: translateY(-10%);
        transition: all 400ms;  
    }
`;
